<div class="d-flex justify-content-center mt-4">

</div>
<div class="d-flex flex-column justify-content-center mt-4">

    <div class="accordion" id="accordionBOperator" *ngFor="let operatorB of listBOperator">
        <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button header-accordion-style" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBOperator" aria-expanded="true" aria-controls="collapseBOperator">
                    {{getBOperatorId(operatorB)}}
                </button>
            </h2>
            <div id="collapseBOperator" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                data-bs-parent="#accordionBOperator">
                <div class="accordion-body">


                    <div id="addNewCountryZeroCountry"
                        class="d-flex justify-content-center mt-2 addNewCountryZeroCountry"
                        (click)="addCountryToBOperator(operatorB)" *ngIf="viewAddCountryZeroCountry(operatorB)">
                        <div class="d-flex align-items-center ">
                            <i class="fa-solid fa-circle-plus fa-2x"></i>
                            <span class="small span-icon">Add Country</span>
                        </div>
                    </div>
                    <div class="accordion mt-2" id="accordionExample" *ngFor="let country of operatorB.listCountry">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button header-accordion-style" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#collapseCountry" aria-expanded="true"
                                    aria-controls="collapseCountry">
                                    {{getCountryName(country)}}
                                </button>
                            </h2>
                            <div id="collapseCountry" class="accordion-collapse collapse show"
                                aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <div class="row mt-4">
                                        <div class="col-md-4">
                                            <label for="countryCustomerId">Country Customer Id *</label>
                                            <input type="text" [(ngModel)]="country.countryCustomerId"
                                                [ngClass]="{'input-error': !country || !country.countryCustomerId}"
                                                class="form-control" id="countryCustomerId" name="countryCustomerId"
                                                placeholder="CountryCustomerId">
                                        </div>
                                        <div class="col-md-4">
                                            <label for="countryName">Country Name *</label>
                                            <select [(ngModel)]="country.countryName"
                                                [ngClass]="{'input-error': !country || !country.countryName}"
                                                class="form-select" id="countryName" name="countryName">
                                                <option value="">Select Country</option>
                                                <option *ngFor="let countryOption of countryOptions" [ngValue]="countryOption">
                                                    {{ countryOption }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-4">
                                            <label for="organizationId">Organization Id</label>
                                            <input type="text" [(ngModel)]="country.organizationId" class="form-control"
                                                id="organizationId" name="organizationId" placeholder="OrganizationId">
                                        </div>

                                    </div>

                                    <div class="row mt-4">
                                        <div class="col-md-4">
                                            <label for="operator">B Operator *</label>
                                            <select [(ngModel)]="country.operator" class="form-select"
                                                [ngClass]="{'input-error': !country || !country.operator}" id="operator"
                                                name="operator" [disabled]="true">
                                                <option value="IMSA">IMSA</option>
                                                <option value="TELIA">TELIA</option>
                                                <option value="ORANGE">ORANGE</option>
                                                <option value="TIM">TIM</option>
                                                <option value="SWISSCOM">SWISSCOM</option>
                                            </select>
                                        </div>
                                        <div class="col-md-4">
                                            <label for="localAgreement">Local Agreements</label>
                                            <select class="form-select" [(ngModel)]="country.localAgreement"
                                                id="localAgreement" name="localAgreement" (ngModelChange)="onChangeLocalAgreement($event, operatorB, country)">
                                                <option *ngFor="let item of tendinaAgreements" [ngValue]="item.id">
                                                    {{ item.id }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-4" title="HH:MM">
                                            <label for="sla">SLA *</label>
                                            <input type="text" [(ngModel)]="country.sla" class="form-control"
                                                id="sla" name="sla" placeholder="SLA">
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <div class="col-md-12">
                                            <label for="note">Note</label>
                                            <textarea class="form-control" id="note" rows="2"
                                                [(ngModel)]="country.note"></textarea>
                                        </div>
                                    </div>

                                    <div class="accordion mt-4" id="accordionDeliveryAddress">
                                        <div class="accordion-item">
                                            <h2 class="accordion-header" id="headingOne">
                                                <button class="accordion-button header-accordion-style" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseDeliveryAddress"
                                                    aria-expanded="true" aria-controls="collapseDeliveryAddress">
                                                    Delivery Address *
                                                </button>
                                            </h2>
                                            <div id="collapseDeliveryAddress" class="accordion-collapse collapse show"
                                                aria-labelledby="headingOne" data-bs-parent="#accordionDeliveryAddress">
                                                <div class="accordion-body">

                                                    <div class="row mt-4">
                                                        <div class="col-md-4">
                                                            <label for="nameDeliveryAddress">First Name</label>
                                                            <input type="text"
                                                                [(ngModel)]="country.deliveryAddress.name"
                                                                class="form-control" id="nameDeliveryAddress"
                                                                name="nameDeliveryAddress" placeholder="Name">
                                                        </div>

                                                        <div class="col-md-4">
                                                            <label for="street">Street Name</label>
                                                            <input type="text"
                                                                [(ngModel)]="country.deliveryAddress.streetName"
                                                                class="form-control" id="street" name="street"
                                                                placeholder="Street">
                                                        </div>

                                                        <div class="col-md-4">
                                                            <label for="streetNumber">Street Number</label>
                                                            <input type="text"
                                                                [(ngModel)]="country.deliveryAddress.streetNr"
                                                                class="form-control" id="streetNumber"
                                                                name="streetNumber" placeholder="StreetNumber">
                                                        </div>


                                                    </div>

                                                    <div class="row mt-4">
                                                        <div class="col-md-4">
                                                            <label for="city">City</label>
                                                            <input type="text"
                                                                [(ngModel)]="country.deliveryAddress.city"
                                                                class="form-control" id="city" name="city"
                                                                placeholder="City">
                                                        </div>

                                                        <div class="col-md-4">
                                                            <label for="country">Country</label>
                                                            <select [(ngModel)]="country.deliveryAddress.country"
                                                                class="form-select" id="country" name="country">
                                                                <option value="">Select Country</option>
                                                                <option *ngFor="let countryOption of countryOptions" [ngValue]="countryOption">
                                                                    {{ countryOption }}
                                                                </option>
                                                            </select>
                                                        </div>

                                                        <div class="col-md-4">
                                                            <label for="postalCode">Postal Code</label>
                                                            <input type="text"
                                                                [(ngModel)]="country.deliveryAddress.postCode"
                                                                class="form-control" id="postalCode" name="postalCode"
                                                                placeholder="PostalCode">
                                                        </div>


                                                    </div>

                                                    <div class="row mt-4">
                                                        <div class="col-md-4">
                                                            <label for="givenName">Last Name</label>
                                                            <input type="text"
                                                                [(ngModel)]="country.deliveryAddress.givenName"
                                                                class="form-control" id="givenName" name="givenName"
                                                                placeholder="GivenName">
                                                        </div>

                                                        <div class="col-md-4">
                                                            <label for="title">Title</label>
                                                            <input type="text"
                                                                [(ngModel)]="country.deliveryAddress.title"
                                                                class="form-control" id="title" name="title"
                                                                placeholder="Title">
                                                        </div>
                                                    </div>



                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                    <div class="d-flex justify-content-center mt-2" (click)="addBillingAccount(country)"
                                        style="cursor: pointer;"
                                        *ngIf="viewAddBillingAccountZeroBillingAccount(country)">
                                        <div class="d-flex align-items-center ">
                                            <i class="fa-solid fa-circle-plus fa-2x"></i>
                                            <span class="small span-icon">Add Billing Account</span>
                                        </div>
                                    </div>






                                    <div class="accordion mt-4" id="accordionBillingAccounts"
                                        *ngFor="let accounts of country.customerBillingAccount">
                                        <div class="accordion-item">
                                            <h2 class="accordion-header" id="headingOne">
                                                <button class="accordion-button header-accordion-style" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseBillingAccount"
                                                    aria-expanded="true" aria-controls="collapseBillingAccount">
                                                    Billing Account
                                                </button>
                                            </h2>
                                            <div id="collapseBillingAccount" class="accordion-collapse collapse show"
                                                aria-labelledby="headingOne" data-bs-parent="#accordionBillingAccounts">
                                                <div class="accordion-body">
                                                    <div class="row mt-4">

                                                        <div class="col-md-4">
                                                            <label for="idBillingAccount">Id</label>
                                                            <input type="text" [(ngModel)]="accounts.id"
                                                                class="form-control" id="idBillingAccount"
                                                                name="idBillingAccount" placeholder="Id">
                                                        </div>

                                                        <div class="col-md-8">

                                                        </div>


                                                    </div>




                                                    <div class="accordion mt-4" id="accordionBillingAddress">
                                                        <div class="accordion-item">
                                                            <h2 class="accordion-header" id="headingOne">
                                                                <button class="accordion-button header-accordion-style"
                                                                    type="button" data-bs-toggle="collapse"
                                                                    data-bs-target="#collapseBillingAddres"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapseBillingAddres">
                                                                    Billing Account Address
                                                                </button>
                                                            </h2>
                                                            <div id="collapseBillingAddres"
                                                                class="accordion-collapse collapse show"
                                                                aria-labelledby="headingOne"
                                                                data-bs-parent="#accordionBillingAddress">
                                                                <div class="accordion-body">

                                                                    <div class="row mt-4">
                                                                        <div class="col-md-4">
                                                                            <label for="nameDeliveryAddress">First Name</label>
                                                                            <input type="text"
                                                                                [(ngModel)]="accounts.address.name"
                                                                                class="form-control"
                                                                                id="nameDeliveryAddress"
                                                                                name="nameDeliveryAddress"
                                                                                placeholder="Name">
                                                                        </div>

                                                                        <div class="col-md-4">
                                                                            <label for="street">Street Name</label>
                                                                            <input type="text"
                                                                                [(ngModel)]="accounts.address.streetName"
                                                                                class="form-control" id="street"
                                                                                name="street" placeholder="Street">
                                                                        </div>

                                                                        <div class="col-md-4">
                                                                            <label for="streetNumber">Street Number</label>
                                                                            <input type="text"
                                                                                [(ngModel)]="accounts.address.streetNr"
                                                                                class="form-control" id="streetNumber"
                                                                                name="streetNumber"
                                                                                placeholder="StreetNumber">
                                                                        </div>


                                                                    </div>

                                                                    <div class="row mt-4">
                                                                        <div class="col-md-4">
                                                                            <label for="city">City</label>
                                                                            <input type="text"
                                                                                [(ngModel)]="accounts.address.city"
                                                                                class="form-control" id="city"
                                                                                name="city" placeholder="City">
                                                                        </div>

                                                                        <div class="col-md-4">
                                                                            <label for="country">Country</label>
                                                                            <select [(ngModel)]="accounts.address.country"
                                                                                class="form-select" id="country"
                                                                                name="country">
                                                                                <option value="">Select Country</option>
                                                                                <option *ngFor="let countryOption of countryOptions" [ngValue]="countryOption">
                                                                                    {{ countryOption }}
                                                                                </option>
                                                                            </select>
                                                                        </div>

                                                                        <div class="col-md-4">
                                                                            <label for="postalCode">Postal Code</label>
                                                                            <input type="text"
                                                                                [(ngModel)]="accounts.address.postCode"
                                                                                class="form-control" id="postalCode"
                                                                                name="postalCode"
                                                                                placeholder="PostalCode">
                                                                        </div>


                                                                    </div>



                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>





                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between mt-2">

                                            <div (click)="addBillingAccount(country)"
                                                *ngIf="viewAddBillingAccount(accounts, country)"
                                                style="cursor: pointer;">
                                                <div class="d-flex align-items-center ">
                                                    <i class="fa-solid fa-circle-plus fa-2x"></i>
                                                    <span class="small span-icon">Add Billing Account</span>
                                                </div>
                                            </div>

                                            <div (click)="removeBillingAccount(country, accounts)"
                                                style="cursor: pointer;">
                                                <div class="d-flex align-items-center ">
                                                    <i class="fa-solid fa-x fa-2x"></i>
                                                    <span class="small span-icon">Remove Billing Account</span>
                                                </div>
                                            </div>





                                        </div>


                                    </div>







                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between flex-row mt-2">

                            <div (click)="addCountryToBOperator(operatorB)" *ngIf="viewAddCountry(operatorB, country)"
                                style="cursor: pointer;">
                                <div class="d-flex align-items-center ">
                                    <i class="fa-solid fa-circle-plus fa-2x">

                                    </i>
                                    <span class="small span-icon">Add Country</span>
                                </div>
                            </div>

                            <div (click)="removeCountry(operatorB, country)"
                               class="removeCountry">
                                <div class="d-flex align-items-center ">
                                    <i class="fa-solid fa-x fa-2x"></i>
                                    <span class="small span-icon">Remove Country</span>
                                </div>
                            </div>





                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

</div>

<div class="row mt-4">
    <span class="span-error" *ngIf="customerDataCountryFormDisabled()">Add at least one country and fill in all
        mandatory fields marked with
        * to save or go to the next step</span>
</div>
<div class="d-flex justify-content-end mt-4">
    <button class="btn btn-primary btn-lg active back-button btn-sm"
        (click)="backToStepCustomerDataBOperator()">Back</button>
    <button class="btn btn-primary btn-lg active btn-sm" style="margin-left:2%;"
        [disabled]="customerDataCountryFormNextDisabled()" (click)="goToStepCustomerAffiliate()">Next</button>
    <button class="btn btn-primary btn-lg active button-save btn-sm"
        [disabled]="customerDataCountryFormDisabled() || disabledForm()" (click)="saveCustomer()">Save</button>
    <button class="btn btn-primary btn-lg active button-reset btn-sm" [disabled]="disabledForm()"
        (click)="resetForm()">Reset</button>
</div>
